export default __webpack_public_path__ + "static/media/a3651330c8c6922b.3bf6e7d54468ab9931ff7bf2106daea3.svg";